import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import WCCountriesList from './views/WCCountriesList';
import WCCountryDetail from './views/WCCountryDetail';

const COUNTRY_ID_PARAM = 'countryId';

const WCCountries = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const countryId = searchParams.get(COUNTRY_ID_PARAM);

  //ELIMINA PARAMS DE OTRAS VISTAS 
    useEffect(() => {
        setSearchParams(
          prev => {
            const next = new URLSearchParams(prev);
            next.delete('screen');
            next.delete("stage_code")
            next.delete("matchId")
            next.delete("subTab")
            return next;
          },
          { replace: true },
        );
      }, []);

  return countryId ? <WCCountryDetail /> : <WCCountriesList />;
};

export default WCCountries;
